import type { UseQueryOptions } from '@tanstack/react-query';

import { scheduledAppsListEaiControlledDeviceIds } from '@repo/sdk/funcs/scheduledAppsListEaiControlledDeviceIds';
import { SDKError } from '@repo/sdk/models/errors';
import { ListEaiControlledDeviceIdsRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface ListEaiControlledDeviceIdsQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
}

export const listEaiControlledDeviceIdsQuery = ({
  agentId,
  client,
}: ListEaiControlledDeviceIdsQueryProps): UseQueryOptions<
  string[],
  SDKError,
  string[] | undefined
> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'listEaiControlledDeviceIds'],
    queryFn: () =>
      client<ListEaiControlledDeviceIdsRequest, string[]>({
        gaiaFunc: scheduledAppsListEaiControlledDeviceIds,
        request: { agentId: agentId! },
      }),
    staleTime: Infinity,
  };
};
